import * as React from "react"
import type { SVGProps } from "react"
const SvgMoneyFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4 19q-.82 0-1.41-.59-.6-.59-.59-1.41V7q0-.82.59-1.41Q3.18 4.99 4 5h16q.83 0 1.41.59.6.59.59 1.41v10q0 .83-.59 1.41-.59.6-1.41.59zm13-2h3v-3q-1.23 0-2.12.88Q17 15.77 17 17m-2.87-2.87A3 3 0 0 1 12 15a3 3 0 0 1-2.12-.87A3 3 0 0 1 9 12q0-1.25.88-2.12A3 3 0 0 1 12 9q1.25 0 2.13.88.87.87.87 2.12t-.87 2.13M20 7v3q-1.23 0-2.12-.88A3 3 0 0 1 17 7zM4 10q1.24 0 2.12-.88Q7 8.23 7 7H4zm0 4q1.24 0 2.12.88Q7 15.77 7 17H4z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMoneyFilled
